import React, { useState, useEffect, useRef } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate, Outlet } from 'react-router-dom';
import { io } from 'socket.io-client';
import Header from './components/Header';
import Dashboard from './components/Dashboard';
import Home from './pages/Home'; // Importa o componente Home
import Clients from './pages/Clients'; // Corrigido o caminho
import StockManager from './pages/StockManager'; // Corrigido o caminho
import Reports from './components/Reports'; // Importa o novo componente
import Login from './pages/Login';
import ProtectedRoute from './context/ProtectedRoute';
import { AuthProvider, useAuth } from './context/AuthContext'; // Corrigido o caminho
import Kiosk from './pages/kiosk'; // Importa a nova página do Totem
 
const MainLayout = ({ isSoundEnabled, handleToggleSound }) => {
  const [socket, setSocket] = useState(null);
  const { user } = useAuth(); // Pega o usuário logado
  const notificationSoundRef = useRef(new Audio('/notification.mp3')); // 1. Cria a ref para o áudio aqui

  // A conexão do socket agora é criada aqui, dentro do layout protegido.
  useEffect(() => {
    // Usa a variável de ambientepara a URL do bakend em produção, 
    // ou localhost para desenvolvimento.
    const backendUrl = process.env.REACT_APP_BACKEND_URL || 'http://localhost:3000';
    const newSocket = io(backendUrl, {
      path: '/api/socket.io',
      transports: ['websocket', 'polling'], // Garante que ambos os transportes são tentados
      auth: {
        username: user?.username || 'unknown'
      }
    });
    setSocket(newSocket);

    // Fecha a conexão quando o componente é desmontado (ex: no logout)
    return () => newSocket.close();
  }, [user]);

  return (
    <div style={{ display: 'flex', flexDirection: 'column', height: '100vh' }}>
      <Header isSoundEnabled={isSoundEnabled} onToggleSound={handleToggleSound} />
      <main style={{ flexGrow: 1, display: 'flex', overflow: 'hidden' }}>
        <Outlet context={{ socket, isSoundEnabled, notificationSoundRef }} />
      </main>
    </div>
  );
};

const AppContent = () => {
  const [isSoundEnabled, setIsSoundEnabled] = useState(() => {
    const saved = localStorage.getItem('soundEnabled');
    return saved !== null ? JSON.parse(saved) : true;
  });

  const handleToggleSound = () => {
    const newSoundState = !isSoundEnabled;
    setIsSoundEnabled(newSoundState);
    localStorage.setItem('soundEnabled', JSON.stringify(newSoundState));
  };

  return (
    <Routes>
      {/* Rotas Públicas */}
      <Route path="/" element={<Home />} />
      <Route path="/login" element={<Login />} />
      
      {/* Rota do Totem de Autoatendimento (Pública, sem layout de admin) */}
      <Route path="/totem" element={<Kiosk />} />

      {/* Rotas Protegidas que usam o MainLayot */}
      <Route
        element={
          <ProtectedRoute> {/* Protege o acesso ao layoutrincipal */}
            <MainLayout isSoundEnabled={isSoundEnabled} handleToggleSound={handleToggleSound} />
          </ProtectedRoute>
        }
      >
        {/* Rotas filhas que qualquer usuário logado pode ver */}
        <Route path="/dashboard" element={<Dashboard />} /> 
        <Route path="/clientes" element={<Clients />} /> 
        
        {/* Rotas filhas que exigem um nível de acesso específico (admin) */}
        <Route path="/stock" element={<ProtectedRoute allowedRoles={['admin']}><StockManager /></ProtectedRoute>} /> 
        <Route path="/relatorios" element={<ProtectedRoute allowedRoles={['admin']}><Reports /></ProtectedRoute>} /> 
      </Route>

      {/* Redirecionamento para rotas não encontradas */}
      <Route path="*" element={<Navigate to="/login" replace />} />
    </Routes>
  );
};

const App = () => (
  <Router>
    <AuthProvider>
      <AppContent />
    </AuthProvider>
  </Router>
);

export default App;